/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerAccountControllerDtoMyRemoveTwoFactorRequest model module.
 * @module model/ManagerAccountControllerDtoMyRemoveTwoFactorRequest
 * @version 1.0
 */
class ManagerAccountControllerDtoMyRemoveTwoFactorRequest {
    /**
     * Constructs a new <code>ManagerAccountControllerDtoMyRemoveTwoFactorRequest</code>.
     * @alias module:model/ManagerAccountControllerDtoMyRemoveTwoFactorRequest
     * @param password {String} 
     */
    constructor(password) { 
        
        ManagerAccountControllerDtoMyRemoveTwoFactorRequest.initialize(this, password);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, password) { 
        obj['password'] = password;
    }

    /**
     * Constructs a <code>ManagerAccountControllerDtoMyRemoveTwoFactorRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerAccountControllerDtoMyRemoveTwoFactorRequest} obj Optional instance to populate.
     * @return {module:model/ManagerAccountControllerDtoMyRemoveTwoFactorRequest} The populated <code>ManagerAccountControllerDtoMyRemoveTwoFactorRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerAccountControllerDtoMyRemoveTwoFactorRequest();

            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerAccountControllerDtoMyRemoveTwoFactorRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerAccountControllerDtoMyRemoveTwoFactorRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ManagerAccountControllerDtoMyRemoveTwoFactorRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['password'] && !(typeof data['password'] === 'string' || data['password'] instanceof String)) {
            throw new Error("Expected the field `password` to be a primitive type in the JSON string but got " + data['password']);
        }

        return true;
    }


}

ManagerAccountControllerDtoMyRemoveTwoFactorRequest.RequiredProperties = ["password"];

/**
 * @member {String} password
 */
ManagerAccountControllerDtoMyRemoveTwoFactorRequest.prototype['password'] = undefined;






export default ManagerAccountControllerDtoMyRemoveTwoFactorRequest;

